<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="1"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="2" defaultSel="7"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">
                <el-table :data="listData" style="width: 100%">
                    <el-table-column prop="createTime" label="入住时间"></el-table-column>
                    <el-table-column prop="shopName" label="门店名称"></el-table-column>
                    <el-table-column prop="address" label="地址"></el-table-column>
                    <el-table-column prop="contacts" label="联系人"></el-table-column>
                    <el-table-column prop="mobile" label="联系电话"></el-table-column>

                    <el-table-column label="惠点饭票收单状态">
                        <template slot-scope="scope">
                            <p v-if="scope.row.isOpen == 1" class="color_orage">开启中</p>
                            <p v-else class="color_gray">未开启</p>
                        </template>
                    </el-table-column>

                    <el-table-column prop="mtReceive" label="惠点饭票累计收单次数"></el-table-column>
                    <el-table-column prop="collection" label="门店粉丝数"></el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>
  
<script>
var util = require("@/common/util.js");
import CryptoJS from 'crypto-js';
import { API_MENDIAN } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            listData: [],
            dialog: false,
            name: '',
            wxName: ''
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        getListData() {
            let params = {}
            util.getData(API_MENDIAN, params, (res) => {
                this.listData = res.data.data
                // for(let i=0; i<=res.data.data.length; i++){
                //     this.listData.push(res.data.data[i])
                // }
            })
        }
    }
}
</script>
  
<style lang="less">
.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}
.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
    .color_orage{
        color: orange;
    }
    .color_gray{
        color: #999999;
    }
}

.nav_search {
    margin-top: 10px;
    margin-bottom: 30px;
}

.order_input1 {
    margin-bottom: 20px;
}</style>


// WEBPACK FOOTER //
// src/pages/GlyMd/index.vue